export default "__VITE_ASSET__DovS_Nd3__"